<template>
  <div>
    <el-tabs v-model="tabValue" @tab-click="handleClick">
      <el-tab-pane label="玩家" name="玩家">
        <PlayerListPage v-if="tabValue == '玩家'" />
      </el-tab-pane>
      <el-tab-pane label="灰名单" name="灰名单">
        <GreyListPage v-if="tabValue == '灰名单'" />
      </el-tab-pane>
      <el-tab-pane label="黑名单" name="黑名单">
        <BlackListPage v-if="tabValue == '黑名单'" />
      </el-tab-pane>
      <el-tab-pane label="分区访问" name="分区访问">
        <ZoneVisitWhiteListPage v-if="tabValue == '分区访问'" />
      </el-tab-pane>
      <el-tab-pane label="GM白名单" name="GM白名单">
        <WhiteListEntryOfGmPage v-if="tabValue == 'GM白名单'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
  
<script>
import PlayerListPage from "./tab-pages/PlayerListPage";
import ZoneVisitWhiteListPage from "./tab-pages/ZoneVisitWhiteListPage";
import GreyListPage from "./tab-pages/GreyListPage";
import BlackListPage from "./tab-pages/BlackListPage";
import WhiteListEntryOfGmPage from "./tab-pages/WhiteListEntryOfGmPage";
export default {
  data() {
    return {
      tabValue: "玩家",
    };
  },

  async created() {
    let tab = this.$route.query.tab;
    if (tab) {
      switch (tab) {
        case "playerList": {
          this.tabValue = "玩家";

          break;
        }
        case "grey-list": {
          this.tabValue = "灰名单";
          break;
        }
        case "black-list": {
          this.tabValue = "黑名单";
          break;
        }
      }
    }
  },

  components: {
    PlayerListPage,
    ZoneVisitWhiteListPage,
    GreyListPage,
    BlackListPage,
    WhiteListEntryOfGmPage,
  },

  methods: {
    handleClick(tab, event) {
      this.$router.push({ query: {} });
    },
  },
};
</script>